import React from 'react'
import { Card } from 'reactstrap';

const MyBragSheetForm = (props) => {
    const studentData = props.studentData;
    return (

        <Card className="p-3">
            <label>
                First Name:
                <input
                    type="text"
                    name="firstName"
                    value={studentData.firstname}
                    disabled
                />
            </label>
            <label>
                Last Name:
                <input
                    type="text"
                    name="lastName"
                    value={studentData.lastname}
                    disabled
                />
            </label>
            <label>
                Grade Level:
                <input
                    type="text"
                    name="gradeLevel"
                    value={studentData.grade}
                    disabled
                />
            </label>
            <label>
                Email Address:
                <input
                    type="email"
                    name="email"
                    value={studentData.email}
                    disabled
                />
            </label>
            <label>
                Date Updated:
                <input
                    type="date"
                    name="date"
                    value={studentData.date}
                    onChange={(e) => {

                        //console.log("Date");
                        //console.log(e.target.value);
                        props.setStudentData(x => ({ ...x, date: e.target.value }))
                    }}
                    disabled
                />
            </label>
            <label>
                Phone Number:
                <input
                    type="tel"
                    name="phone"
                    value={studentData.mobile}
                    placeholder="Enter your phone number"
                    disabled
                />
            </label>
        </Card>
    )
}

export default MyBragSheetForm